/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportCostSampleExamsType
 */
export interface ReportCostSampleExamsType {
    /**
     * 
     * @type {object}
     * @memberof ReportCostSampleExamsType
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportCostSampleExamsType
     */
    sum: object;
}

export function ReportCostSampleExamsTypeFromJSON(json: any): ReportCostSampleExamsType {
    return ReportCostSampleExamsTypeFromJSONTyped(json, false);
}

export function ReportCostSampleExamsTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportCostSampleExamsType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportCostSampleExamsTypeToJSON(value?: ReportCostSampleExamsType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


